import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class WorkflowStepCompletedTrigger extends BaseEntityModel {
  id?: number;

  key?: number;

  stepName?: string;

  constructor(model: Partial<WorkflowStepCompletedTrigger> = {}) {
    super(model);

    this.id = model.id;
    this.key = model.key;
    this.stepName = model.stepName;
  }
}
